import React from "react";

const Table = ({ headers, rows, zIndex = 0 }) => {
  return (
    <div
      className="relative overflow-x-auto border border-gray-400 rounded-lg"
    >
      {/* Table Container */}
      <div style={{ overflowX: "auto", overflowY: "auto" }}>
        <table className="w-full text-xs text-left rtl:text-right table-auto">
          {/* Table Header */}
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr
              style={{
                position: "sticky",
                top: 0,
                zIndex: zIndex,
                background: "white",
              }}
            >
              {/* Dynamic Headers */}
              {headers.map((header, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-2 py-2 border-b border-gray-400"
                  style={{
                    whiteSpace: "nowrap", // Prevent text wrapping in headers
                  }}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody style={{
            boxShadow: "0px 0px 10px 0px lightGray",
            maxWidth: "100%",
            maxHeight: "200px",
            overflow: "auto",
          }}>
            {rows && rows.length > 0 ? (
              rows.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={`${rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } border-b`}
                >
                  {/* Render Each Cell Dynamically */}
                  {headers.map((header, colIndex) => (
                    <td
                      key={colIndex}
                      className="px-2 text-gray-500"
                      style={{
                        whiteSpace: "nowrap", // Prevent text wrapping in cells
                      }}
                    >
                      {/* Render Value */}
                      {row[header.key] || "-"}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={headers.length}
                  className="text-center py-4 text-lg text-gray-500 font-medium"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
